<template>
  <v-container>
    <v-row>
    	<v-col cols="12">
    		<v-card>
    		  <v-card-title primary-title>
    		    Notificación
    		  </v-card-title>

    		  <!-- Token -->
    		  <div class="ml-4">{{ tokenFirebase }}</div>

    		  <br/>
    		  <br/>
    		  <br/>

    		  <v-card-actions class="ml-2">
    		    <v-btn color="primary" rounded @click="initialize( )">iniciar</v-btn>
    		  </v-card-actions>

    		</v-card>
    	</v-col>
    </v-row>
  </v-container>
</template>

<script>
	// Push notifications desactivadas
	// import {
	//   ActionPerformed,
	//   PushNotificationSchema,
	//   PushNotifications,
	//   Token,
	// } from '@capacitor/push-notifications';

  export default {
  	data: () => ({
  		tokenFirebase:'eeee',
  	}),

  	methods:{
  		async initialize ( ) {
			  console.log('Push notifications desactivadas');
		    // PushNotifications.requestPermissions().then(result => {
		    //   if (result.receive === 'granted') {
		    //     PushNotifications.register();
		    //   }
		    // });
		    //
		    // PushNotifications.addListener('registration', token => {
		    // 	this.tokenFirebase = token.value
	      //   console.info('Push registration success, token: ' + token.value);
	      // });
		    //
		    // PushNotifications.addListener('registrationError', error => {
	      //   console.info('Error on registration: ' + JSON.stringify(error));
	      // });
		    //
		    // PushNotifications.addListener('pushNotificationReceived', notification => {
	      //   alert('Push received: ' + JSON.stringify(notification));
	      // });
		    //
		    // PushNotifications.addListener('pushNotificationActionPerformed', notification => {
	      //   alert('Push action performed: ' + JSON.stringify(notification));
	      // });
  		},

  		async listarNotificaciones( ){
  		},

  		async obtenerToken ( ){
  			
  		}
  	}
  };
</script>